// extracted by mini-css-extract-plugin
module.exports = {"noResultsWrapper":"noresults_noResultsWrapper__OSrHN"};